var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalesPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#6C5CE7",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 15.25C10.5 13.1789 12.1789 11.5 14.25 11.5H31.75C33.8211 11.5 35.5 13.1789 35.5 15.25V32.75C35.5 34.8211 33.8211 36.5 31.75 36.5H14.25C12.1789 36.5 10.5 34.8211 10.5 32.75V15.25ZM14.25 12.75H31.75C33.1307 12.75 34.25 13.8693 34.25 15.25V19.625H11.75V15.25C11.75 13.8693 12.8693 12.75 14.25 12.75ZM11.75 20.875V32.75C11.75 34.1307 12.8693 35.25 14.25 35.25H31.75C33.1307 35.25 34.25 34.1307 34.25 32.75V20.875H11.75Z",
    fill: "#2D3436"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 16.5C16.75 17.1904 16.1904 17.75 15.5 17.75C14.8096 17.75 14.25 17.1904 14.25 16.5C14.25 15.8096 14.8096 15.25 15.5 15.25C16.1904 15.25 16.75 15.8096 16.75 16.5Z",
    fill: "#2D3436"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 16.5C20.5 17.1904 19.9404 17.75 19.25 17.75C18.5596 17.75 18 17.1904 18 16.5C18 15.8096 18.5596 15.25 19.25 15.25C19.9404 15.25 20.5 15.8096 20.5 16.5Z",
    fill: "#2D3436"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.25 16.5C24.25 17.1904 23.6904 17.75 23 17.75C22.3096 17.75 21.75 17.1904 21.75 16.5C21.75 15.8096 22.3096 15.25 23 15.25C23.6904 15.25 24.25 15.8096 24.25 16.5Z",
    fill: "#2D3436"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesPage);
export default __webpack_public_path__ + "static/media/sales-page.9ae73d80a834c39f54d4f7d1db87434a.svg";
export { ForwardRef as ReactComponent };